module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "products",
    attrs: {
      "id": "products"
    }
  }, [_c('div', {
    staticClass: "products-content"
  }, [_c('a', {
    staticClass: "product product-blue",
    attrs: {
      "href": "http://www.hihonor.com/se/products/mobile-phones/honor9/index.html",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "product product-black",
    attrs: {
      "href": "http://www.hihonor.com/se/products/mobile-phones/honor9/index.html",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "product product-grey",
    attrs: {
      "href": "http://www.hihonor.com/se/products/mobile-phones/honor9/index.html",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear: both;"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9bfa45ea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Products.vue
// module id = 233
// module chunks = 1